import { render, staticRenderFns } from "./Support5.vue?vue&type=template&id=de997a24&scoped=true"
import script from "./Support5.vue?vue&type=script&lang=js"
export * from "./Support5.vue?vue&type=script&lang=js"
import style0 from "./Support5.vue?vue&type=style&index=0&id=de997a24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de997a24",
  null
  
)

export default component.exports